import socialMedia from '../../assets/social-media.svg';
import styles from '../styles/Footer.module.scss';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer>
      <div className={styles.row1}>
        <div className="containerFixed">
          <div className={styles.col} style={{ flex: 1.5 }}>
            <h6>About Us</h6>
            <p>
              Stargid Event Management was found by three members who spent hard times managing events and built the solution that they could not find
              elsewhere
            </p>
            <a href="#social-media" style={{ marginTop: '1rem' }}>
              <img src={socialMedia} alt="" />
            </a>
            <div className={styles.social}></div>
          </div>
          <div className={styles.col}>
            <h6>Quick Links</h6>
            <ul>
              <li>
                <Link to="about-us">About Us</Link>
              </li>
              <li>
                <Link to="how-it-works">How it works</Link>
              </li>
              <li>
                <Link to="signup">Sign up</Link>
              </li>
              <li>
                <Link to="contact-us">Contact Us</Link>
              </li>
              <li>
                <Link to="terms-and-conditions">Terms &amp; Conditions</Link>
              </li>
            </ul>
          </div>
          <div className={styles.col}>
            <h6>Help &amp; Support</h6>
            <p>Sales: sales@stargid.com</p>
            <p>Support Phone: +49-17620652337</p>
            <p>Support Email: support@stargid.com</p>
            <p>
              <strong>Stargid main office</strong>
            </p>
            <p>22117 Hamburg, Germany</p>
          </div>
        </div>
      </div>
      <div className={styles.row2}>
        <div className="containerFixed">&copy; 2021, Stargid - All Rights Reserved</div>
      </div>
    </footer>
  );
};

export default Footer;
